export const tr = {
    'request-error': 'Beklenmeyen hata oluştu.'
};
